var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo",attrs:{"a":_vm.$store.getters['menu/test']},on:{"click":_vm.goHome}},[_c('img',{attrs:{"src":require("@/assets/logo.png")}})])}
var staticRenderFns = []

export { render, staticRenderFns }